import { render, staticRenderFns } from "./singleProductView.vue?vue&type=template&id=03efd206&scoped=true&"
import script from "./singleProductView.vue?vue&type=script&lang=js&"
export * from "./singleProductView.vue?vue&type=script&lang=js&"
import style0 from "./singleProductView.vue?vue&type=style&index=0&id=03efd206&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03efd206",
  null
  
)

export default component.exports